import { socialExportProductionAudio } from '../audio/index.ts';

export const EXPORT_AUDIO_RIGHTS_MANIFEST = Object.freeze({
  version: 3,
  policy: 'explicitly_social_export_cleared_or_reaction_consent',
  sources: Object.freeze([]),
  conditional: Object.freeze([
    'reaction_microphone_with_explicit_opt_in_and_session_local_recording',
  ]),
  excluded: Object.freeze([
    'page_audio',
    'ambient_system_audio',
    'licensed_music',
    'unrelated_user_media',
  ]),
});

export function resolvedExportAudioAssetIds(): readonly string[] {
  return socialExportProductionAudio()
    .filter(
      (asset) =>
        asset.source !== 'project-authored-procedural' &&
        (asset.bus === 'ride' || asset.bus === 'wind' || asset.bus === 'environment'),
    )
    .map((asset) => asset.id);
}

export const EXPORT_RIDE_AUDIO_AVAILABLE = resolvedExportAudioAssetIds().length > 0;
